import { render } from "./create-ext-users.vue?vue&type=template&id=1d1829a6"
import script from "./create-ext-users.vue?vue&type=script&lang=js"
export * from "./create-ext-users.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__